__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@ams-micro/main";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ams-micro/common", "0.0.1", function() { return function() { return __webpack_require__(5539); }; }, 1);
			register("@voyo/http", "3.6.2", function() { return function() { return __webpack_require__(5453); }; }, 1);
			register("@ztwx/utils", "1.13.0", function() { return function() { return __webpack_require__(9720); }; }, 1);
			register("vue-property-decorator", "8.5.1", function() { return function() { return __webpack_require__(4717); }; }, 1);
			register("vue-router", "3.6.5", function() { return function() { return __webpack_require__(1917); }; }, 1);
			register("vuex", "3.6.2", function() { return function() { return __webpack_require__(9572); }; }, 1);
			initExternal(2266);
			initExternal(7713);
			initExternal(9574);
			initExternal(1390);
			initExternal(1776);
			initExternal(3462);
			initExternal(4583);
			initExternal(3204);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};